export default __webpack_public_path__ + "static/media/EM1930.34I-42970_-25671_0.9c6954bb.jpg";